export default "__VITE_ASSET__7uXCzoaL__"